<template>
    <div class="form-group vue-month-selector-input-container">
        <v-month-picker-custom @change-month-name="changeMonthName" @change="change" v-model="value" v-slot>
            <input type="text" class="form-control" :value="name" @keydown="$event.preventDefault();">
        </v-month-picker-custom>
    </div>
</template>

<script>
    import VMonthPickerCustom from './v-month-picker-custom.vue';
    import props from './props.js';

    export default {
        components: {
            VMonthPickerCustom
        },
        props: props,
        data() {
            return {
                name: ''
            }
        },
        methods: {
            changeMonthName(name) {
                this.name = name;
            },
            change(month) {
                this.$emit('change', month);
            }
        }
    };
</script>